/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Jr_4_DInputs */

const en_cp_jr_4_d = /** @type {(inputs: Cp_Jr_4_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builders: P2MW, PKM-K, incubators, 1000 Startup, Indigo. Solvers: PKM-KC, Gemastik, KMIPN, thesis. The documents are already done.`)
};

const id_cp_jr_4_d = /** @type {(inputs: Cp_Jr_4_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builder: P2MW, PKM-K, inkubator, 1000 Startup, Indigo. Solver: PKM-KC, Gemastik, KMIPN, skripsi. Dokumennya sudah jadi.`)
};

/**
* | output |
* | --- |
* | "Builders: P2MW, PKM-K, incubators, 1000 Startup, Indigo. Solvers: PKM-KC, Gemastik, KMIPN, thesis. The documents are already done." |
*
* @param {Cp_Jr_4_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_jr_4_d = /** @type {((inputs?: Cp_Jr_4_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Jr_4_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_jr_4_d(inputs)
	return en_cp_jr_4_d(inputs)
});